module.exports = __webpack_public_path__ + "static/media/mosquito-template.a74fda48.png";